import {
  Avatar,
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2 as Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../assets/js/Icons";
import moment from "moment";
import { chipVariants } from "../../../pages/Specialist/Dashboard/appointments/data";

function AppointmentDetails() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.otherSlice);
  const appointment = data?.appointment;
  const timeZone = data?.specialistTimeZone || appointment?.timezone;

  const handleClose = () => {
    dispatch(hideDialog());
  };

  const formatTime = (utc) => moment(utc).tz(timeZone).format("h:mm A");
  const formatDate = (utc) => moment(utc).tz(timeZone).format("MM-DD-YYYY");

  if (!appointment) return null;

  return (
    <Paper sx={{ overflow: "hidden" }}>
      <DialogTitle sx={{ position: "relative", pb: 1 }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "22px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          Appointment Details
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers sx={{ py: 3, maxHeight: "65vh", overflowY: "auto" }}>
        <Stack spacing={3}>
          {/* Member Profile */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Avatar 
              src={appointment?.member?.image} 
              sx={{ width: 56, height: 56 }} 
            />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600, textTransform: "capitalize" }}>
                {appointment?.member?.fullName}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Member Profile
              </Typography>
            </Box>
          </Stack>

          <Divider />

          {/* Details Grid */}
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="caption" color="text.secondary" display="block">
                Appointment Date
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatDate(appointment?.startTime)}
              </Typography>
            </Grid>
            
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="caption" color="text.secondary" display="block">
                Appointment Time
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatTime(appointment?.startTime)} - {formatTime(appointment?.endTime)}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="caption" color="text.secondary" display="block">
                Booking Date
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatDate(appointment?.createdAt)}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="caption" color="text.secondary" display="block">
                Status
              </Typography>
              <Chip
                size="small"
                variant="statusChip"
                color={chipVariants[appointment?.appointmentStatus] || "primary"}
                label={
                  appointment?.appointmentStatus === "no-show" || appointment?.appointmentStatus === "no_show_specialist"
                    ? "No Show"
                    : appointment?.appointmentStatus === "expired" ? "Expired" : appointment?.appointmentStatus
                }
                sx={{ mt: 0.5, textTransform: "capitalize" }}
              />
            </Grid>
          </Grid>

          <Divider />

          {/* Notes */}
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
              Notes from Member
            </Typography>
            <Paper 
              variant="outlined" 
              sx={{ 
                p: 2, 
                bgcolor: "#fcfcfc", 
                borderRadius: "6px",
                borderColor: "#eaeaea"
              }}
            >
              <Typography 
                variant="body2" 
                color="text.primary" 
                sx={{ 
                  whiteSpace: "pre-wrap", 
                  wordBreak: "break-word",
                  fontStyle: appointment?.notes ? "normal" : "italic",
                  color: appointment?.notes ? "text.primary" : "text.secondary"
                }}
              >
                {appointment?.notes || "No notes provided for this appointment."}
              </Typography>
            </Paper>
          </Box>
        </Stack>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2, pt: 2 }}>
        <Button onClick={handleClose} variant="contained" color="primary" fullWidth>
          Close
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default AppointmentDetails;
